module.exports = __webpack_public_path__ + "1_0_62/img/android-button.a0560e00.png";